import { CHUNK_SIZE, CHUNK_VOLUME } from "./constants";
import { BlockType } from "./block-registry";

export type ChunkData = {
  readonly cx: number; // chunk X coordinate
  readonly cz: number; // chunk Z coordinate
  readonly cy: number; // chunk Y coordinate (vertical section)
  readonly blocks: Uint16Array; // CHUNK_VOLUME entries
  dirty: boolean;
};

export function createChunk(cx: number, cy: number, cz: number): ChunkData {
  return {
    cx,
    cy,
    cz,
    blocks: new Uint16Array(CHUNK_VOLUME),
    dirty: true,
  };
}

export function getBlockIndex(x: number, y: number, z: number): number {
  return x + z * CHUNK_SIZE + y * CHUNK_SIZE * CHUNK_SIZE;
}

export function getBlock(chunk: ChunkData, x: number, y: number, z: number): number {
  if (x < 0 || x >= CHUNK_SIZE || y < 0 || y >= CHUNK_SIZE || z < 0 || z >= CHUNK_SIZE) {
    return BlockType.AIR;
  }
  return chunk.blocks[getBlockIndex(x, y, z)];
}

export function setBlock(
  chunk: ChunkData,
  x: number,
  y: number,
  z: number,
  blockId: number
): ChunkData {
  const newBlocks = new Uint16Array(chunk.blocks);
  newBlocks[getBlockIndex(x, y, z)] = blockId;
  return { ...chunk, blocks: newBlocks, dirty: true };
}

export function worldToChunkCoord(worldCoord: number): number {
  return Math.floor(worldCoord / CHUNK_SIZE);
}

export function worldToLocalCoord(worldCoord: number): number {
  return ((worldCoord % CHUNK_SIZE) + CHUNK_SIZE) % CHUNK_SIZE;
}

export function chunkKey(cx: number, cy: number, cz: number): string {
  return `${cx},${cy},${cz}`;
}
